export default "__VITE_ASSET__40cc8e9f__"